import * as React from 'react';
import style from '../../../LibraryView.scss';
import { sectionPrefix } from '../../../../NavigationMenu/utils';
import { EventDetails } from './EventDetails';
import { CodeExamples } from '../../../../CodeExamples';
import { IntersectionSubscriber } from '../../../../SectionIntersectionDetection/IntersectionSubscriber';
import { findInMessagesByName } from '../../../../../../utils/treeVisitors/helpers';

export const Event = ({ event, prefix, node }) => {
  const eventData = findInMessagesByName(node, event.type);
  const hashPrefix = sectionPrefix(prefix, event.urlFormat);
  const JSLayoutType = node?.data?.layoutType === 'JS';
  return (
    <section
      key={`__section_${event.name}`}
      className={style.sectionWrapper}
      data-hook={`event-${event.urlFormat}`}
    >
      <IntersectionSubscriber
        tagName="tag"
        className={style.intersectionSubscriber}
        id={hashPrefix}
      />
      <EventDetails
        message={eventData}
        event={event}
        hashPrefix={hashPrefix}
        node={node}
      />
      <CodeExamples
        data={{ ...eventData, eventType: event.eventType, isEvent: true }}
        prefix={prefix}
        JSLayoutType={JSLayoutType}
      />
    </section>
  );
};
